import { render, staticRenderFns } from "./ipBlockList.vue?vue&type=template&id=0003b8b6&scoped=true&"
import script from "./ipBlockList.vue?vue&type=script&lang=js&"
export * from "./ipBlockList.vue?vue&type=script&lang=js&"
import style0 from "./ipBlockList.vue?vue&type=style&index=0&id=0003b8b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0003b8b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0003b8b6')) {
      api.createRecord('0003b8b6', component.options)
    } else {
      api.reload('0003b8b6', component.options)
    }
    module.hot.accept("./ipBlockList.vue?vue&type=template&id=0003b8b6&scoped=true&", function () {
      api.rerender('0003b8b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/safe/child/ipBlockList.vue"
export default component.exports